export const ICO_ADDRESS = "0x9B31afC8fae912C1C10f82f379eCcf10CFB41B11";
